import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { translationChunksConfig } from '@spartacus/assets';
import {
  CmsConfig,
  ConfigModule,
  I18nModule,
  provideConfig,
} from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CustomProdPgModule } from '../custom-prod-pg/custom-prod-pg.module';
import { CustomPdpComponent } from './custom-pdp/custom-pdp.component';

@NgModule({
  declarations: [CustomPdpComponent],

  imports: [
    CommonModule,
    MediaModule,
    I18nModule,
    SlickCarouselModule,
    NgbModule,
    FormsModule,
    CustomProdPgModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductIntroComponent: {
          component: CustomPdpComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class CustomPdpModule {}
